import 'slick-carousel';

export default function run() {
    let $sliders = $('.module.featured_posts_slider');

    if ($sliders.length) {

        $sliders.each(function (index, el) {

            let $slider = $(el).find('.slider-container');

            $slider.slick({
                centerMode: true,
                dots: true,
                arrows: true,
                centerPadding: '0',
                slidesToShow: 1,
                adaptiveHeight: true,
                accessibility: true,
                speed: 450,
                draggable: true,
                autoplay: true,
                autoplaySpeed: 6000,
                pauseOnHover: true,
                rows: 0
            });

        });

    }

}



// WEBPACK FOOTER //
// ./template-parts/modules/content-featured_posts_slider/script.js